/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Guide_Rias_P1Inputs */

const es_marketplace_seo_galicia_guide_rias_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Rias_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las Rías Baixas — Vigo, Pontevedra, Arousa y Muros-Noia — ofrecen aguas protegidas ideales para navegar en familia. Cada ría tiene su carácter: la de Vigo abraza las Cíes; la de Arousa acoge Sálvora y Arousa; Pontevedra invita a calas más íntimas.`)
};

const gl_marketplace_seo_galicia_guide_rias_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Rias_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As Rías Baixas — Vigo, Pontevedra, Arousa e Muros-Noia — ofrecen augas protexidas ideais para navegar en familia. Cada ría ten o seu carácter: a de Vigo abraza as Cíes; a de Arousa acolle Sálvora; Pontevedra convida a calas máis íntimas.`)
};

const en_marketplace_seo_galicia_guide_rias_p1 = /** @type {(inputs: Marketplace_Seo_Galicia_Guide_Rias_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rías Baixas — Vigo, Pontevedra, Arousa and Muros-Noia — offer sheltered waters ideal for family boating. Each ria has its character: Vigo faces the Cíes; Arousa holds Sálvora; Pontevedra offers quieter coves.`)
};

/**
* | output |
* | --- |
* | "Rías Baixas — Vigo, Pontevedra, Arousa and Muros-Noia — offer sheltered waters ideal for family boating. Each ria has its character: Vigo faces the Cíes; Aro..." |
*
* @param {Marketplace_Seo_Galicia_Guide_Rias_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_guide_rias_p1 = /** @type {((inputs?: Marketplace_Seo_Galicia_Guide_Rias_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Guide_Rias_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_guide_rias_p1(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_guide_rias_p1(inputs)
	return es_marketplace_seo_galicia_guide_rias_p1(inputs)
});